import { uploadAttachment } from '@connect-x-app/hybrid-data-access';
import { ApiError, AttachmentUpload, QueryKeys } from '@connect-x-app/shared-domain-models';
import { useMutation } from '@tanstack/react-query';

export const useUploadAttachment = () => {
  const { mutateAsync } = useMutation<
    AttachmentUpload,
    ApiError,
    {
      channelId: string;
      clientMessageId: string;
      file: File | { name: string; type: string; uri: string };
      roomId: string;
    }
  >({
    mutationFn: variables => uploadAttachment(variables.file, variables.channelId, variables.roomId, variables.clientMessageId),
    mutationKey: [QueryKeys.UPLOAD_ATTACHMENT],
  });

  return (file: File, channelId: string, roomId: string, clientMessageId: string) =>
    mutateAsync({ channelId, clientMessageId, file, roomId });
};
